import {Card} from "@fluentui/react-components";

function ParticipantCbCard({ participant, checked, onChange }) {
    return (
        <Card className={`card-small`} style={{ width: "100%" }}>
            <label
                style={{display: "flex", flexDirection: "row", justifyContent: "start", gap: 5}}>

                <input
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                />

                {participant.fullName}
            </label>
        </Card>
    );
}

export default ParticipantCbCard;
